
(function (Drupal, $, window) {

  Drupal.behaviors.basic = {
    attach: function (context, settings) {

      // Behaviours re-attach after AJAX (plan servings, plan editor), so
      // page-level handlers are bound once (Ali, 16 Oct: the servings pills
      // left the phone menu and tabs firing twice).
    	$(once('gravit-iframe-embed', '[data-iframe-embed]', context)).click(function(e) {
    		e.preventDefault();
    		var $t = $(this);

    		var url = $t.data('iframe-embed');
    		if (url != '') {
    			url += "?autoplay=1&title=0&badge=0&byline=0&portrait=0"
                $t.data('iframe-embed', '');

    			var $iframe = $('<div class="responsive-embed"></div>').hide();

    			var $p = $t.parents('.page-wrapper').find('.'+$t.data('prepend')).first();
    			var y = $p.offset().top-30;

    			$p.prepend($iframe);
    			$iframe.html('<iframe seamless allowfullscreen frameborder="0" src="'+url+'" />');
    			$iframe.slideDown(333);

    			$('html, body').animate({scrollTop: y}, 333);
    		}
    	});

        $('.collapsed').addClass('hide').hide();

        $(once('gravit-collapse', '[data-collapse]', context)).click(function(event) {
            event.preventDefault();
            var $t = $(this);

            var el = $t.data('collapse');
            var $el = $(el);
            $t.fadeTo(333, 0);
            $el.removeClass('hide').slideDown(333, function() {

            });
        });


        $(once('collapse-title', '.collapse-title', context)).each(function () {
            //event.preventDefault();
            $(this).on('click', function(e) {
              var $t = $(this);
              var $el = $t.next();

              if ($t.hasClass('closed')) {
                $el.removeClass('hide').slideDown(250);
                $t.removeClass('closed');
              } else {
                $el.slideUp(125, function() {
                  $el.hide().addClass('hide');
                  $t.addClass('closed');
                });
              }
              return true;
            });
        });


        $(once('gravit-section-user-form', '.section-user form', context)).each(function() {
          var $f = $(this);
          $f.find('input,select').change(function() {
            $f.find('#edit-submit').removeClass('disabled');
          });
          $f.find('#edit-submit').click(function(e) {
            if ($(this).hasClass('disabled')) {
              e.preventDefault();
            }
            $(this).addClass('disabled');
          });
        });


        // enable tabs
        $('.view-ajax-args-toggle').each(function(e) {
          var $t = $(this);
          var $view = $t.parents('.view');
          if (jQuery.isEmptyObject(Drupal.views.instances)) {
            $t.find('[data-arg]').first().addClass('is-active');
            return false;
          }

          $.each( Drupal.views.instances , function getInstance( index, instance) {
              if($(instance.refreshViewAjax.selector)[0] == $view[0]) {
                  var active = instance.settings.view_args;
                  // assumption, if more than one view arg, use the LAST view arg. Assuming this is a filter at the end of a chain of other contextual filters
                  if (instance.settings.view_args.indexOf('/') != -1) {
                    n = instance.settings.view_args.lastIndexOf('/');
                    active = instance.settings.view_args.substring(n + 1);
                  }

                  $t.find('[data-arg="'+active+'"]').addClass('is-active');
                  return true;
              }
          });
        });


        // Move images from recipe into hero
        if ($('.swiper-full .swiper-wrapper')[0]) {
            $('.field--name-field-recipe img').each(function() {
                var $t = $(this);
                var url = $t.attr('src');
                url = url.replace('/sites/default/files/', '/sites/default/files/styles/fullscreen_banner/public/');
                var $fig = $('<figure class="swiper-slide"><img src="'+url+'" /></figure>');

                $('.swiper-full .swiper-wrapper').append($fig);
                $t.remove();
            });
        }

        $(once('gravit-mobile-nav', '.mobile-nav')).click(function() {
          // Members get the prototype's menu (member-menu.js).
          if ($('body').hasClass('user-logged-in')) {
            return;
          }
          var $head = $('#site-header');
          if ($head.hasClass('active')) {
            $head.find('.footer-items').remove();
          } else {
            var fc = $('.footer-top .columns').html();
            var $fi = $('<div class="footer-items"><div class="outer-wrapper">'+fc+'</div></div>');
            $head.find('.header-bottom').append($fi);
          }
          $head.toggleClass('active');
        })

        $('.swiper-component').each(function() {
          var $t = $(this);
          var $nextEl = $t.find('.swiper-button-next');
          var $prevEl = $t.find('.swiper-button-prev');
          var $pagination = $t.find('.swiper-pagination');

          var paginationEl = $pagination[0] ? $pagination[0] : null;

          var swiper = new Swiper($(this).find('.swiper-container')[0], {
            // Optional parameters
            direction: 'horizontal',
            // loop: true,
            slidesPerView: 'auto',
            wrapperClass: 'swiper-wrapper',
            mousewheel: false,
            updateOnImagesReady: false,
            //cssMode: true,

            // If we need pagination
            pagination: {
              el: paginationEl//'.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
              nextEl: $nextEl[0],//'.swiper-button-next',
              prevEl: $prevEl[0],//'.swiper-button-prev',
            },


          });
        });

        var showTabContent = function($t) {
          var $tabContent = getContentTabTarget($t);
          $t.addClass('is-active');
          $tabContent.show();
        }

        var hideTabContent = function($t) {
          var $tabContent = getContentTabTarget($t);
          $t.removeClass('is-active');
          $tabContent.hide();
        }

        var getContentTabTarget = function($t) {
          var $scope = $t.parents('article');
          if (!$scope[0]) {
            $scope = $t.parents('.content');
          }
          if ($t.data('target')) {
            return $scope.find('[data-tab="'+$t.data('target')+'"]');
          } else if ($t.data('class')) {
            return $scope.find('.tab-content.'+$t.data('class'));
          }
        }

        $(once('gravit-show-target', 'body')).on('click', '[data-show-target]', function(e) {
          e.preventDefault();
          var $tab = $(this);
          $tab.closest('.content').find('[data-show-id="'+$tab.data('show-target')).show();
          $tab.hide();
        });


        $(once('gravit-ajax-args-toggle', 'body')).on('click', '.view-ajax-args-toggle [data-arg]', function(e) {
          e.preventDefault();
          var $tab = $(this);

          if ($tab.hasClass('is-active')) {
            return;
          }

          $tab.parents('.view-ajax-args-toggle').find('.is-active').removeClass('is-active');
          $tab.addClass('is-active');

          var $view = $tab.parents('.view');
          $.each( Drupal.views.instances , function getInstance( index, instance) {
                if(instance.$view[0] == $view[0]) {
                    // assumption, if more than one view arg, edit the LAST view arg. Assuming this is a filter at the end of a chain of other contextual filters
                    if (instance.settings.view_args.indexOf('/') != -1) {
                      n = instance.settings.view_args.lastIndexOf('/');
                      instance.settings.view_args = instance.settings.view_args.substring(0, n) + "/" + $tab.data('arg');
                    } else {
                      instance.settings.view_args = $tab.data('arg');
                    }

                    $view.trigger('RefreshView');
                    return;
                }
            });
        });


        $(once('gravit-refresh-view', 'body')).on('click', '.refresh-view', function(e) {
          e.preventDefault();
          var $tab = $(this);
          var $view = $tab.closest('.view');

          // get Prev sibling NID as argument for view
          if ($tab.hasClass('refresh-side')) {
            var $prev = $view.closest('.meal-wrap').prev().find('.node--type-recipe');
            var nid = $prev.attr('id').replace('node-','');
            $.each( Drupal.views.instances , function getInstance( index, instance) {
                  if(instance.$view[0] == $view[0]) {
                      var args = instance.settings.view_args.split('/');
                      args[0] = nid;
                      instance.settings.view_args = args.join('/');
                  }
              });

          }

          if ($tab.hasClass('refresh-filters')) {
            $view.find('.view-filters form .js-form-submit').first().trigger('click');
          } else {
            $view.trigger('RefreshView');
          }

        });




        $(once('gravit-content-tabs', 'body')).on('click', '.content-tabs a, .content-tabs button, .content-tabs li span', function(e) {
          e.preventDefault();
          var $tab = $(this);
          if ($tab.hasClass('is-active')) {
            return;
          }

          var $tabs = $tab.parents('.content-tabs');
          var $current = $tabs.find('.is-active');

          if (!$current[0]) {
            var $old = $tabs.find('a, .tab').not($tab);
            $old.each(function() {
              hideTabContent($(this));
            });
          } else {
            hideTabContent($current);
          }

          showTabContent($tab);

        });

        var hash = once('gravit-tab-hash', 'body').length ? window.location.hash.substr(1) : '';
        if (hash) {
          if ($('.content-tabs')[0]) {
            $tab = $('.content-tabs a[data-class="tab-'+hash+'"]');
            if ($tab[0]) {
              $tab.trigger('click');
            }
          }
        }

        // check anchor for tabs

        /*
        $('.content-tabs a, .content-tabs button').each(function() {
          var $tabContent = getContentTabTarget($(this));
          if (!$tabContent[0]) {
            $(this).hide();
          }
        });
        */

        $(once('gravit-my-diet-load', '#my-diet-load', context)).click(function(evt) {
          evt.preventDefault();
          var $t = $(this);
          $t.addClass('click');
          var $form = $(this).parents('form');

          var diets = $t.data('diet');
          if (diets) {
            // clear values from initial diet form element
            var $diet = $form.find('#edit-diet');//.next('.select2');
            $diet.find('option:selected').removeAttr('selected');
            for (var d in diets) {
              $diet.find('option[value="'+diets[d]+'"]').prop('selected', 'selected');
            }
            $diet.trigger('change');
          }

          var ingredients_avoid = $t.data('ingredients-avoid');
          if (ingredients_avoid) {
            // clear values from initial diet form element, tricky cause its ajax populated
            var $ingfield = $(this).parents('form').find('#edit-ingredients-avoid');
            $ingfield.find('option').remove();
            $ingfield.trigger('change');

            // programatically set options, in future add title in if available in data-attr
            for (var i in ingredients_avoid) {
              var option = new Option('... ', ingredients_avoid[i], true, true);
              $ingfield.append(option);
            }

            //$ingfield.trigger('change');
            // manually trigger the `select2:select` event
            /*
            studentSelect.trigger({
                type: 'select2:select',
                params: {
                    data: data
                }
            });
            */
          }

          var ingredients_allow = $t.data('ingredients-allow');
          if (ingredients_allow) {
            // clear values from initial diet form element, tricky cause its ajax populated
            var $ingfield = $(this).parents('form').find('#edit-ingredients-allow');
            $ingfield.find('option').remove();
            $ingfield.trigger('change');

            // programatically set options, in future add title in if available in data-attr
            for (var i in ingredients_allow) {
              var option = new Option('... ', ingredients_allow[i], true, true);
              $ingfield.append(option);
            }


          }

          $form.submit();

        });


        $('.view-recipes .views-exposed-form').each(function() {
          if (!$('body').hasClass('user-logged-in') || $('body').hasClass('user-not-sub')) {

            var $t = $(this);
            var $first = $t.find('input,select,details').not('.form-text,.form-submit').prop('disabled', true).addClass('disabled').first();

            $t.find('.form-submit').each(function() {

              $first.before($(this));
            })

            var text = $('body').hasClass('user-not-sub') ?
              '<p class="form-alert">Please <a href="/renew">upgrade</a> your account to use advanced search.</p>' :
              '<p class="form-alert">Please log in to use advanced search.</p>';

            $first.before(text);
          }
        });


        // MODIFY meal plan paragraphs with modification query param onto node
        $('.paragraph--type--meal[data-m]').each(function() {
          var $t = $(this);
          var m = $t.data('m');
          var ml = $t.data('ml');

          var $links = $t.find('.node--type-recipe').not('.contextual').find('a');
          if ($links.length && $links.attr('href')) {
              var currentHref = $links.attr('href');
              if (currentHref.indexOf('?m=') === -1) {
                  $links.attr('href', currentHref + '?m=' + m);
              }
          }


        });

        $(once('gravit-login-destination', 'body:not(.user-logged-in) a[href="/user"], body:not(.user-logged-in) a[href="/user/login"]', context)).click(function(e) {
          e.preventDefault();

          var url = $(this).attr('href');
          if (window.location.pathname) {
            url += '?destination='+window.location.pathname;
          }
          window.location = url;
        });


        $(once('gravit-focus-view-all', 'body:not(.user-logged-in) a.bi-arrow-right', context)).click(function(e) {
          var $t = $(this);
          if ($t.text() == 'View All') {
            e.preventDefault();
            $('body').append('<script src="//m.nourishingmeals.com/focus/2.js" type="text/javascript" charset="utf-8" async="async"></script>');
          } else if ($t.text() == 'View More' || $t.text() == 'View More ') {
            e.preventDefault();
            $('body').append('<script src="//m.nourishingmeals.com/focus/1.js" type="text/javascript" charset="utf-8" async="async"></script>');
          }
        });

        $(once('gravit-focus-link-list', 'body:not(.user-logged-in) .link-list a', context)).click(function(e) {
          var $t = $(this);
          if ($t.attr('href').startsWith('/recipes/search')) {
            e.preventDefault();
            $('body').append('<script src="//m.nourishingmeals.com/focus/3.js" type="text/javascript" charset="utf-8" async="async"></script>');
          }
        });
        /*
        // Full calendar JS stuff placed here for convienence, should be packaged into a library eventually
        const calendarObserver = new MutationObserver(function(mutations_list) {
          mutations_list.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(added_node) {
              console.log(added_node);
              if(added_node.className == 'fc-view-container') {
                var $calEl = $(added_node).parents('.js-drupal-fullcalendar');
                calendarObserver.disconnect();
                modifyFullCalendar($calEl);
              }
            });
          });
        });

        console.log(document.querySelector(".view-nm-calendar"));

        calendarObserver.observe(
          document.querySelector(".view-nm-calendar"),
          {
            subtree: false,
            childList: true
          }
        );
        */

        // Forum tab switching
        $(once('forum-tabs', '.forum-tabs-strip', context)).each(function() {
          var $tabs = $(this);
          var $view = $tabs.closest('.view-forum');

          var updateTabs = function() {
            var $activeTab = $tabs.find('.forum-tab-link.active');
            var tab = $activeTab.data('tab');

            // Find all potential content areas
            var $recent = $view.find('> .view-content, > .view-empty, > .pager');
            var $attachmentsWrapper = $view.find('> .attachment');
            var $individualAttachments = $view.find('.view-display-id-attachment_following, .view-display-id-attachment_popular');

            $recent.hide();
            $individualAttachments.hide();
            $attachmentsWrapper.hide();

            if (tab === 'recent') {
              $recent.show();
            } else {
              $attachmentsWrapper.show();
              var $target = $view.find('.view-display-id-attachment_' + tab);
              $target.show();
            }
          };

          $tabs.on('click', '.forum-tab-link', function(e) {
            e.preventDefault();
            var $t = $(this);
            $tabs.find('.forum-tab-link').removeClass('active');
            $t.addClass('active');
            updateTabs();
          });

          // Initial call
          updateTabs();
        });

      // "425°F", "350 degrees F", "350–375°F" → °C (nearest degree). Same rule
      // in the print view (RecipePrintController::celsius()).
      function nmFahrenheitToCelsius(text) {
        return text.replace(/(\d+)(?:\s*(?:-|–|to)\s*(\d+))?\s*(?:°\s*|degrees?\s+)?F\b/gi, function (match, from, to) {
          var c = function (f) { return Math.round((parseInt(f, 10) - 32) * 5 / 9); };
          return to ? c(from) + '–' + c(to) + '°C' : c(from) + '°C';
        });
      }

      // Metric unit toggle for recipe ingredients/steps
      var metricConversions = {
        'can' : { to: 'ml', factor: 355, singular: 'can', plural: 'cans' },
        'cup': { to: 'ml', factor: 237, singular: 'cup', plural: 'cups' },
        'tbs': { to: 'ml', factor: 15, singular: 'tablespoon', plural: 'tablespoons' },
        'tsp': { to: 'ml', factor: 5, singular: 'teaspoon', plural: 'teaspoons' },
        'pt' : {to: 'ml', factor: 473, singular: 'pint', plural: 'pints' },
        'pn': { to: 'g', factor: 0.36, singular: 'pinch', plural: 'pinches' },
        'oz': { to: 'g', factor: 28, singular: 'ounce', plural: 'ounces' },
        'lb': { to: 'g', factor: 454, singular: 'pound', plural: 'pounds' },
        'inch' : {to: 'cm', factor: 2.5, singular: 'inch', plural: 'inches' },
        'bn' : {to: 'bunch', factor: 1, singular: 'bunch', plural: 'bunches' },
        'clv' : {to: 'clove', factor: 1, singular: 'clove', plural: 'cloves' },
      };

      $('.metric-toggle-wrapper').prependTo('.field--name-field-ingredients');

      // Amounts in metric or back, from the amount on screen: the servings
      // scale (nm_meal_plan.js) keeps the scaled amount in data-v, the
      // original in data-d.
      function nmApplyUnits(toMetric) {
        $('[data-d]').each(function () {
          var $el = $(this);
          var $unitSpan = $el.siblings('.unit[data-unit]');

          // Search for Shopping List structure
          if (!$unitSpan.length) {
            $unitSpan = $el.closest('.qty').siblings('.unit[data-unit]');
          }

          var unitKey = $unitSpan.length ? $unitSpan.data('unit').toLowerCase() : '';
          var conversion = metricConversions[unitKey];
          if (!conversion) {
            return;
          }
          // The unit as rendered ("cup" + plural suffix), restored on the
          // way back so the servings scale can still toggle the suffix.
          if ($unitSpan.data('nmHtml') === undefined) {
            $unitSpan.data('nmHtml', $unitSpan.html());
          }
          var amount = parseFloat($el.attr('data-v') || $el.data('d'));

          if (toMetric) {
            if (!$el.hasClass('metric-class')) {
              $el.data('nmImperial', $el.text());
            }
            $el.text(Math.round(amount * conversion.factor * 10) / 10);
            $el.addClass('metric-class');
            $unitSpan.text(' ' + conversion.to);
          }
          else if ($el.hasClass('metric-class')) {
            $el.text($el.data('nmImperial'));
            $el.removeClass('metric-class');
            $unitSpan.html($unitSpan.data('nmHtml'));
            $unitSpan.find('.suffix').toggleClass('hide', !(amount > 1));
          }
        });
      }

      // Servings changed while in metric: the scale has just written the
      // new imperial amounts; keep them for the way back and convert.
      $(once('metric-rescale', 'body')).on('nm-servings-scaled', function () {
        if ($('#metric-toggle').data('unit') === 'metric') {
          $('[data-d].metric-class').removeClass('metric-class');
          nmApplyUnits(true);
        }
      });

      $(once('metric-toggle', '#metric-toggle')).on('click', function () {
        var $btn = $(this);
        var toMetric = $btn.data('unit') === 'imperial';

        nmApplyUnits(toMetric);

        // Directions: oven temperatures follow the toggle (°F → °C, rounded
        // to the degree as in the prototype). Volumes in the free text stay.
        // Text only: each text node keeps its original, so the steps and
        // their checkoff buttons (gravit_overrides recipe-actions.js) stay
        // the same elements.
        $('.field--name-field-recipe .field__item').each(function () {
          var walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
          var node;
          while ((node = walker.nextNode())) {
            if (node.nmOriginalText === undefined) {
              node.nmOriginalText = node.nodeValue;
            }
            node.nodeValue = toMetric ? nmFahrenheitToCelsius(node.nmOriginalText) : node.nmOriginalText;
          }
        });

        // Print in the units shown on the page.
        $('a.btn-print').each(function () {
          var url = new URL(this.href, window.location.href);
          if (toMetric) {
            url.searchParams.set('units', 'metric');
          }
          else {
            url.searchParams.delete('units');
          }
          this.href = url.pathname + url.search;
        });

        $btn.addClass(toMetric ? 'enabled' : '').removeClass(toMetric ? '' : 'enabled');
        $btn.data('unit', toMetric ? 'metric' : 'imperial');
      });

      // Store original unit values on page load
      $('.unit[data-unit]').each(function () {
        $(this).data('original', $(this).text());
      });

      // References toggle functionality
      var $refBlocks = $('#ingredients-references, #nutrients-references, #references, .block-field-blocktaxonomy-termingredientsfield-references, .block-field-blocktaxonomy-termnutrientsfield-references, .block-field-blocknodeingredientfield-references');

      $refBlocks.each(function() {
        var $block = $(this);
        var $title = $block.find('h2, h3, .block-title').first();
        var $content = $block.find('.references-content, .field--name-field-references').first();

        if ($title.length && $content.length && !$title.find('.references-toggle').length) {
          $title.append('<span class="references-toggle"></span>');
          $title.css('cursor', 'pointer');

          // Initially closed
          $content.hide();

          $title.on('click', function() {
            $content.toggle();
            $block.toggleClass('references-is-open');
          });
        }
      });

      // Back to Top button logic
      var $backToTop = $(once('gravit-back-to-top', '#back-to-top'));
      if ($backToTop.length) {
        $(window).scroll(function() {
          if ($(window).scrollTop() > 400) {
            $backToTop.addClass('visible');
          } else {
            $backToTop.removeClass('visible');
          }
        });

        $backToTop.click(function(e) {
          e.preventDefault();
          $('html, body').animate({scrollTop: 0}, 600);
        });
      }

      // Forum Alerts Dropdown
      $(once('forum-alerts-dropdown', '.forum-alerts-dropdown-wrapper', context)).each(function() {
        var $wrapper = $(this);
        var $btn = $wrapper.find('.forum-alerts-btn');
        var $content = $wrapper.find('.forum-alerts-dropdown-content');

        // Add a close button if it doesn't exist
        if (!$content.find('.forum-alerts-close-btn').length) {
          $content.prepend('<button class="forum-alerts-close-btn" aria-label="Close alerts">&times;</button>');
        }

        // Add a "Mark all read" button to the notifications header.
        var $header = $content.find('.view-header');
        if ($header.length && !$header.find('.forum-mark-all-read').length) {
          $header.append('<button class="forum-mark-all-read">Mark all read</button>');
        }
        // Lists that keep read alerts (nm_family_profile) are cleared
        // separately.
        var clearUrl = settings.nmForumAlerts && settings.nmForumAlerts.clearUrl;
        if (clearUrl && $header.length && !$header.find('.forum-clear-alerts').length) {
          $header.append('<button class="forum-clear-alerts">Clear</button>');
        }

        function setUnread(count) {
          $header.contents().filter(function() { return this.nodeType === 3; }).first().replaceWith(String(count));
          if (!count) {
            $btn.removeClass('has-alerts').find('.forum-alerts-badge').remove();
          }
        }

        function showEmpty() {
          $content.find('.views-row').remove();
          $content.find('.view-empty').remove();
          $content.find('.view-content').append('<div class="view-empty">No notifications available.</div>');
        }

        $btn.on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          $content.toggleClass('show');
        });

        $content.on('click', '.forum-alerts-close-btn', function(e) {
          e.preventDefault();
          $content.removeClass('show');
        });

        // Alerts stay in the list until cleared; opening one only marks it read.
        var postWithToken = function(url) {
          return fetch(Drupal.url('session/token'))
            .then(function(response) { return response.text(); })
            .then(function(token) {
              return fetch(url, {method: 'POST', headers: {'X-CSRF-Token': token}});
            });
        };

        var updateBadge = function() {
          var unread = $content.find('.forum-alert.is-unread').length;
          var $badge = $btn.find('.forum-alerts-badge');
          if (unread) {
            if (!$badge.length) {
              $badge = $('<span class="forum-alerts-badge"></span>').appendTo($btn);
            }
            $badge.text(unread);
          }
          else {
            $badge.remove();
            $btn.removeClass('has-alerts');
          }
          if (!$content.find('.views-row').length && !$content.find('.view-empty').length) {
            $content.find('.view-content').append('<div class="view-empty">No notifications available.</div>');
          }
        };

        $content.on('click', '.forum-alert a', function() {
          $(this).closest('.forum-alert').removeClass('is-unread').addClass('is-read');
          updateBadge();
        });

        $content.on('click', '.forum-alert-clear', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var $alert = $(this).closest('.forum-alert');
          postWithToken(Drupal.url('gravit-overrides/notification/' + $alert.data('notification-id') + '/clear')).then(function() {
            $alert.closest('.views-row').remove();
            updateBadge();
          });
        });

        $content.on('click', '.forum-mark-all-read', function(e) {
          e.preventDefault();
          postWithToken(Drupal.url('gravit-overrides/notifications/mark-all-seen')).then(function() {
            if (clearUrl) {
              $content.find('.views-row.is-unread').removeClass('is-unread').addClass('is-read');
              setUnread(0);
              return;
            }
            showEmpty();
            $btn.find('.forum-alerts-badge').remove();
            $btn.removeClass('has-alerts');
          });
        });

        $content.on('click', '.forum-clear-alerts', function(e) {
          e.preventDefault();
          fetch(Drupal.url('session/token')).then(function(response) {
            return response.text();
          }).then(function(token) {
            return fetch(clearUrl, {method: 'POST', headers: {'X-CSRF-Token': token}});
          }).then(function(response) {
            if (response.ok) {
              showEmpty();
              setUnread(0);
            }
          });
        });

        $(document).on('click', function(e) {
          // The list also opens inside the member menu (member-menu.js).
          if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0 && !$(e.target).closest('.nm-member-menu__alerts').length) {
            $content.removeClass('show');
          }
        });
      });

      // Trending topics and card topics filter via AJAX
      $(once('trending-topic-ajax', 'body', context)).on('click', '.trending-topic-name a, .views-field-field-topic a, .forum-card-topic-link a', function(e) {
        var $link = $(this);
        var href = $link.attr('href') || '';
        if (href.indexOf('?') !== -1) {
          var urlParams = new URLSearchParams(href.split('?')[1]);
          var topicId = urlParams.get('field_topic_target_id');

          if (topicId) {
            var $select = $('.view-forum .views-exposed-form select[name="field_topic_target_id"]');
            if ($select.length) {
              e.preventDefault();
              // Set the value and trigger change to fire AJAX
              window.forumFilterTriggeredFromLink = true;
              $select.val(topicId).trigger('change');

              // Scroll up to the view
              $('html, body').animate({
                scrollTop: $('.view-forum').offset().top - 100
              }, 300);
            }
          }
        }
      });

      // Diet tags filter via AJAX
      $(once('diet-tag-ajax', 'body', context)).on('click', '.forum-diet-tag a', function(e) {
        // Skip for the "more/less" tags
        if ($(this).closest('.forum-diet-tag-more').length || $(this).hasClass('forum-diet-tag-less')) return;

        var $link = $(this);
        var href = $link.attr('href') || '';

        var dietId = null;
        if (href.indexOf('/taxonomy/term/') !== -1) {
          dietId = href.split('/taxonomy/term/')[1].split('/')[0].split('?')[0];
        } else if (href.indexOf('?') !== -1) {
          var urlParams = new URLSearchParams(href.split('?')[1]);
          dietId = urlParams.get('field_diet_target_id');
        }

        if (dietId) {
          var $select = $('.view-forum .views-exposed-form select[name="field_diet_target_id"]');
          // A diet missing from the Diet dropdown would leave it on "All" and
          // filter nothing: follow the link instead (the page filters by it).
          if ($select.length && $select.find('option[value="' + dietId + '"]').length) {
            e.preventDefault();
            window.forumFilterTriggeredFromLink = true;
            $select.val(dietId).trigger('change');

            $('html, body').animate({
              scrollTop: $('.view-forum').offset().top - 100
            }, 300);
          }
        }
      });


      // Truncate diet tags if more than 4
      $(once('forum-diet-tags-truncate', '.forum-card-diets', context)).each(function() {
        var $container = $(this);
        var $tags = $container.find('.forum-diet-tag');
        if ($tags.length > 4) {
          var hiddenCount = $tags.length - 4;
          // Hide tags from index 4 onwards
          $tags.slice(4).hide();

          // Add the "+X" chip; clicking reveals the rest and swaps in a "less" link.
          var $moreBtn = $('<div class="forum-diet-tag forum-diet-tag-more"><a href="#">+' + hiddenCount + '</a></div>');
          $container.append($moreBtn);

          $moreBtn.on('click', 'a', function(e) {
            e.preventDefault();
            $tags.slice(4).fadeIn(200);
            $moreBtn.detach();

            // Lowercase Lora "less" link collapses the extra tags back.
            var $lessLink = $('<a href="#" class="forum-diet-tag-less">less</a>');
            $container.append($lessLink);
            $lessLink.on('click', function(e) {
              e.preventDefault();
              $tags.slice(4).hide();
              $lessLink.remove();
              $container.append($moreBtn);
            });
          });
        }
      });

      // Compact number format for community stats (4.5K, 1.2K, 300).
      $(once('forum-compact-stats', '.stat-value', context)).each(function() {
        var $el = $(this);
        var raw = $el.text().trim();
        var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
        if (!isNaN(num)) {
          if (num >= 1000) {
            var k = Math.round((num / 1000) * 10) / 10;
            $el.text((k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)) + 'K');
          } else {
            $el.text(String(num));
          }
        }
      });

      // Forum filter chips + active filter row (diet/topic selected filters).
      $(once('forum-filter-chips', '.view-forum .views-exposed-form', context)).each(function() {
        var $form = $(this);
        var $dietSelect = $form.find('select[name="field_diet_target_id"]');
        var $topicSelect = $form.find('select[name="field_topic_target_id"]');
        var $details = $form.find('.bef--secondary');
        
        if (window.forumFilterTriggeredFromLink) {
          $details.removeAttr('open');
          window.forumFilterTriggeredFromLink = false;
        }
        var $detailsWrapper = $details.find('.details-wrapper');

        // Chips container inside the filter panel (below the selects).
        var $panelChips = $('<div class="forum-filter-chips"></div>');
        $detailsWrapper.append($panelChips);

        // Active filter row, shown when the panel is closed and filters are active.
        var $activeRow = $('<div class="forum-active-filters"><span class="forum-active-filters-label">Filtered by:</span><span class="forum-active-filters-chips"></span><a href="#" class="forum-clear-all">Clear all</a></div>');
        $form.after($activeRow);

        function selectedOptions($select) {
          var out = [];
          $select.find('option:selected').each(function() {
            var val = $(this).val();
            if (val && val !== 'All' && val !== '') {
              // Child terms are prefixed with '-' in the select; drop it on the chip.
              out.push({ value: val, label: $(this).text().trim().replace(/^-+\s*/, '') });
            }
          });
          return out;
        }

        function renderChips() {
          var selected = [];
          if ($dietSelect.length) {
            selectedOptions($dietSelect).forEach(function(s) { s.type = 'diet'; selected.push(s); });
          }
          if ($topicSelect.length) {
            selectedOptions($topicSelect).forEach(function(s) { s.type = 'topic'; selected.push(s); });
          }

          var html = selected.map(function(s) {
            return '<span class="forum-filter-chip forum-filter-chip--' + s.type + '" data-type="' + s.type + '" data-value="' + s.value + '">' + s.label + '<span class="forum-filter-chip-remove" aria-hidden="true">&times;</span></span>';
          }).join('');

          $panelChips.html(html);
          $activeRow.find('.forum-active-filters-chips').html(html);

          var hasFilters = selected.length > 0;
          $panelChips.toggle(hasFilters);
          $activeRow.toggle(hasFilters && !$details[0].open);

          // Update trending topics highlighting based on selected topics
          var activeTopics = selected.filter(function(s) { return s.type === 'topic'; }).map(function(s) { return s.value; });
          $('.block-views-blockforum-block-trending .views-row').removeClass('active');
          if (activeTopics.length > 0) {
            $('.block-views-blockforum-block-trending .views-row a').each(function () {
              var href = $(this).attr('href');
              if (href) {
                for (var j = 0; j < activeTopics.length; j++) {
                  if (href.indexOf('field_topic_target_id=' + activeTopics[j]) !== -1) {
                    $(this).closest('.views-row').addClass('active');
                    break;
                  }
                }
              }
            });
          }
        }

        // Remove a single filter chip.
        $form.add($activeRow).on('click', '.forum-filter-chip-remove', function(e) {
          e.preventDefault();
          var $chip = $(this).closest('.forum-filter-chip');
          var $select = $chip.data('type') === 'diet' ? $dietSelect : $topicSelect;
          $select.find('option[value="' + $chip.data('value') + '"]').prop('selected', false);
          $select.trigger('change');
        });

        // Clear all filters.
        $form.add($activeRow).on('click', '.forum-clear-all', function(e) {
          e.preventDefault();
          $dietSelect.find('option').prop('selected', false);
          $topicSelect.find('option').prop('selected', false);
          $dietSelect.trigger('change');
          $topicSelect.trigger('change');
        });

        $dietSelect.on('change', renderChips);
        $topicSelect.on('change', renderChips);
        $details.on('toggle', renderChips);

        // Add Close button to the bottom of the filter dropdown
        if ($details.length && $details.find('.forum-filter-close-btn').length === 0) {
          var $closeBtnWrap = $('<div class="forum-filter-close-wrapper"></div>');
          var $closeBtn = $('<button type="button" class="button forum-filter-close-btn">Filter</button>');
          $closeBtnWrap.append($closeBtn);
          $details.find('.details-wrapper').append($closeBtnWrap);
          
          $closeBtn.on('click', function(e) {
            e.preventDefault();
            $details.removeAttr('open');
            renderChips();
          });
        }

        $(document).on('click', function(e) {
          if ($details.length && $details[0].open) {
            if (!$(e.target).closest($details).length) {
              $details.removeAttr('open');
              renderChips();
            }
          }
        });

        renderChips();
      });

      // Mobile Actions Dropdown Toggle
      $(once('forumActionsToggle', '.forum-actions-trigger', context)).on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $dropdown = $(this).siblings('.forum-node-actions');
        var $btn = $(this);

        // Close other dropdowns
        $('.forum-node-actions').not($dropdown).removeClass('is-open');
        var $otherBtns = $('.forum-actions-trigger').not($btn);
        $otherBtns.removeClass('is-open');

        $dropdown.toggleClass('is-open');
        $btn.toggleClass('is-open');
      });

      // Close dropdown when clicking outside
      $(once('forumActionsOutsideClick', 'body', context)).on('click', function(e) {
        if (!$(e.target).closest('.forum-node-actions-wrapper').length) {
          $('.forum-node-actions').removeClass('is-open');
          var $btns = $('.forum-actions-trigger');
          $btns.removeClass('is-open');
        }
      });

    }
  };

} (Drupal, jQuery, this));

(function ($, Drupal) {
  Drupal.behaviors.gravitFeedToggleComments = {
    attach: function (context, settings) {
      if ($('body').hasClass('path-community')) {
        $(once('gravitFeedToggleComments', '.forum-replies', context)).on('click', function(e) {
          e.preventDefault();
          var $btn = $(this);
          var $card = $btn.closest('.views-row, .forum-card');
          var $comments = $card.find('.forum-card-inline-comments');
          var $icon = $btn.find('.toggle-icon');

          if ($comments.is(':visible')) {
            $comments.slideUp(200);
            $icon.removeClass('bi-chevron-up').addClass('bi-chevron-down');
            $btn.attr('aria-expanded', 'false');
          } else {
            $comments.slideDown(200);
            $icon.removeClass('bi-chevron-down').addClass('bi-chevron-up');
            $btn.attr('aria-expanded', 'true');
          }
        });

        $(once('gravitFeedCommentPlaceholder', 'form.ajax-comments-form-add textarea, form.ajax-comments-form-reply textarea, form.ajax-comments-form-edit textarea', context)).each(function() {
          $(this).attr('placeholder', 'Write a reply...');
        });
      }
    }
  };
})(jQuery, Drupal);



(function ($, Drupal, window) {
  Drupal.behaviors.gravitLikesUpdate = {
    attach: function (context, settings) {
      // Optimistic update of likes count when clicking the flag link
      $(once('gravitLikesUpdate', '.forum-like', context)).on('click', '.flag', function(e) {
        var $flagWrap = $(this);
        var $countSpan = $flagWrap.closest('.forum-like').find('.forum-action-count');
        
        if ($countSpan.length) {
          var text = $countSpan.text();
          var match = text.match(/(\d+)/);
          if (match) {
            var count = parseInt(match[1]);
            // If it currently has 'action-unflag', it means it is currently flagged, so click will unflag it
            if ($flagWrap.hasClass('action-unflag')) {
              count--;
            } else {
              count++;
            }
            if (count < 0) count = 0;
            
            var newText = text.replace(/\d+/, count);
            $countSpan.text(newText);
          }
        }
      });
    }
  };
  Drupal.behaviors.gravitLikesUpdate = {
    attach: function (context, settings) {
      // Use standard click delegation on document to avoid any once() issues with replaced elements
      $(document).once('gravitLikesUpdate').on('click', '.forum-like a.use-ajax', function(e) {
        var $btn = $(this);
        var $wrapper = $btn.closest('.flag');
        var $countSpan = $btn.closest('.forum-like').find('.forum-action-count');
        
        if ($wrapper.hasClass('is-optimistic-updating')) {
          return;
        }
        $wrapper.addClass('is-optimistic-updating');

        if ($countSpan.length) {
          var text = $countSpan.text();
          var match = text.match(/(\d+)/);
          var count = 0;
          if (match) {
            count = parseInt(match[1], 10);
          }
          
          // action-unflag means the entity IS flagged right now, so this click will UNFLAG it.
          if ($wrapper.hasClass('action-unflag')) {
            count--;
          } else {
            count++;
          }
          
          if (count < 0) count = 0;
          
          if (match) {
            $countSpan.text(text.replace(/\d+/, count));
          } else {
            $countSpan.text(count + ' likes');
          }
          
          // Optimistically toggle class so visual state is correct even before AJAX completes
          if ($wrapper.hasClass('action-unflag')) {
            $wrapper.removeClass('action-unflag').addClass('action-flag');
          } else {
            $wrapper.removeClass('action-flag').addClass('action-unflag');
          }
          
          setTimeout(function() {
            $wrapper.removeClass('is-optimistic-updating');
          }, 500);
        }
      });
    }
  };
  // Use Vanilla JS capturing phase to bypass Drupal's AJAX stopPropagation
  var gravitLikesListenerAdded = false;
  Drupal.behaviors.gravitLikesUpdate = {
    attach: function (context, settings) {
      if (!gravitLikesListenerAdded) {
        gravitLikesListenerAdded = true;
        document.addEventListener('click', function(e) {
          var btn = e.target.closest('.forum-like a.use-ajax');
          if (!btn) return;
          
          var clickedFlagWrap = btn.closest('.flag');
          if (!clickedFlagWrap) return;
          
          if (clickedFlagWrap.classList.contains('is-optimistic-updating')) {
            return;
          }
          
          // Determine if we are liking or unliking based on the clicked element
          var isUnflagging = clickedFlagWrap.classList.contains('action-unflag');

          // Find the unique identifier class e.g. js-flag-like-1234
          var matchClass = clickedFlagWrap.className.match(/(js-flag-[a-zA-Z0-9_-]+)/);
          var wrappersToUpdate = [clickedFlagWrap];
          if (matchClass) {
            wrappersToUpdate = Array.from(document.querySelectorAll('.' + matchClass[1]));
          }

          wrappersToUpdate.forEach(function(flagWrap) {
            if (flagWrap.classList.contains('is-optimistic-updating')) return;
            flagWrap.classList.add('is-optimistic-updating');
            
            var forumLike = flagWrap.closest('.forum-like');
            if (!forumLike) return;
            
            var countSpan = forumLike.querySelector('.forum-action-count');
            if (!countSpan) return;

            var text = countSpan.innerText || countSpan.textContent;
            var match = text.match(/(\d+)/);
            var count = 0;
            if (match) {
              count = parseInt(match[1], 10);
            }
            
            if (isUnflagging) {
              count--;
            } else {
              count++;
            }
            
            if (count < 0) count = 0;
            
            if (count === 1) {
              countSpan.textContent = '1 like';
            } else {
              countSpan.textContent = count + ' likes';
            }
            
            if (isUnflagging) {
              flagWrap.classList.remove('action-unflag');
              flagWrap.classList.add('action-flag');
            } else {
              flagWrap.classList.remove('action-flag');
              flagWrap.classList.add('action-unflag');
            }
            
            setTimeout(function() {
              flagWrap.classList.remove('is-optimistic-updating');
            }, 500);
          });
        }, true); // true = capturing phase
      }
    }
  };

  Drupal.behaviors.gravitRepliesCount = {
    attach: function (context, settings) {
      if (context === document) {
        $(document).ajaxComplete(function(event, xhr, settings) {
          if (settings.url && settings.url.indexOf('ajax_comments') !== -1) {
            $('.forum-discussion-card, .forum-discussion-full-card').each(function() {
              var $card = $(this);
              var $scope = $card.hasClass('forum-discussion-full-card')
                ? $card.closest('.forum-discussion-full-wrapper')
                : $card;
              if (!$scope.length) {
                $scope = $card;
              }
              var $comments = $scope.find('.js-comment');
              var numComments = $comments.length;
              var $countSpan = $card.find('.forum-action-count').first();
              
              if ($countSpan.length) {
                var textNode = null;
                $countSpan.contents().each(function() {
                  if (this.nodeType === 3 && this.nodeValue.trim().length > 0) {
                    textNode = this;
                  }
                });
                var pluralText = numComments === 1 ? ' reply ' : ' replies ';
                if (textNode) {
                  textNode.nodeValue = numComments + pluralText;
                } else {
                  var $icon = $countSpan.find('.toggle-icon');
                  if ($icon.length) {
                    $countSpan.text(numComments + pluralText).append($icon);
                  } else {
                    $countSpan.text(numComments + pluralText.trim());
                  }
                }
              }
            });
          }
        });
      }
    }
  };

  Drupal.behaviors.gravitForumImagesSwiper = {
    attach: function (context, settings) {
      // Find BOTH .field__items AND ul inside .forum-images-grid
      var selector = '.forum-discussion-card:not(.forum-discussion-full-card) .forum-images-grid .field__items, .forum-discussion-card:not(.forum-discussion-full-card) .forum-images-grid ul';
      var $elements = typeof once !== 'undefined' 
        ? $(once('forumSwiper', selector, context)) 
        : $(selector, context).once('forumSwiper');
        
      $elements.each(function () {
        var $items = $(this);
        var $images = $items.children('.field__item, li');
        
        if ($images.length > 4) {
          // Always use .forum-images-grid as the container so we can reliably remove its class
          var $container = $items.closest('.forum-images-grid');
          
          if ($container.length) {
            $container.removeClass('forum-images-grid').addClass('swiper-container forum-feed-carousel');
            
            // Clean up item-list wrappers if they exist
            if ($items.parent().hasClass('item-list')) {
              $items.unwrap();
            }
            
            $items.removeClass('field__items').addClass('swiper-wrapper');
            $images.removeClass('field__item').addClass('swiper-slide');
            
            $container.append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
            
            // Override display just in case
            $images.each(function() {
              this.style.setProperty('display', 'flex', 'important');
            });
            
            if (typeof Swiper !== 'undefined') {
              new Swiper($container[0], {
                direction: 'horizontal',
                slidesPerView: 4,
                spaceBetween: 10,
                navigation: {
                  nextEl: $container.find('.swiper-button-next')[0],
                  prevEl: $container.find('.swiper-button-prev')[0],
                }
              });
            }
          }
        }
      });
    }
  };
})(jQuery, Drupal, window);

